import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function PoissonChart({ poissonDisplay }) {
  const labels = ["PoissonMomentum"];

  const data = {
    labels,
    datasets: [
      {
        label: "Score",
        data: [poissonDisplay],
        backgroundColor:
          poissonDisplay <= 40
            ? "#FF0000" // vermelho (baixo)
            : poissonDisplay <= 70
            ? "#007BFF" // azul (médio)
            : "#00FF66", // verde (alto)
      },
    ],
  };

  const options = {
    scales: {
      y: {
        min: 0,
        max: 100,
        title: { display: true, text: "Score (0-100)", color: "#fff" },
        ticks: { color: "#fff" },
        grid: { color: "#1A1F2E" },
      },
      x: {
        ticks: { color: "#fff" },
        grid: { color: "#1A1F2E" },
      },
    },
    plugins: {
      title: {
        display: true,
        text: "PoissonMomentum Normalizado",
        color: "#00FF66",
        font: { size: 16, weight: "bold" },
      },
      legend: { labels: { color: "#fff" } },
    },
  };

  return <Bar data={data} options={options} />;
}
